module.exports = "/assets/data/d0bb3759998265b91ccc28f34808a23e-CT6.data.json";